export const getId = (prefix?: string): string => {
  const id = new Date().getTime().toString();

  return prefix ? `${prefix}_${id}` : id;
};
